// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `#282828`,
	"blue300": `#ae82d8`,
	"blue50": `#262429`,
	"blue600": `#cdb4e6`,
	"bronze": `#d58a49`,
	"gold": `#967000`,
	"green300": `#bce2ae`,
	"green50": `#252922`,
	"green600": `#bce2ae`,
	"neutral100": `#ffffff`,
	"neutral15": `#353535`,
	"neutral30": `#414141`,
	"neutral45": `#8c9196`,
	"neutral75": `#aaafb4`,
	"platinum": `#6f727d`,
	"primary200": `#53356f`,
	"primary300": `#ae82d8`,
	"primary50": `#39234f`,
	"primary600": `#cdb4e6`,
	"primary700": `#ece0f9`,
	"red300": `#ffb39f`,
	"red50": `#2b2422`,
	"red600": `#c12335`,
	"silver": `#717578`,
	"surface1": `#141414`,
	"surface2": `#202020`,
	"yellow300": `#fffaac`,
	"yellow50": `#4F4E38`,
	"yellow600": `#b85306`
};
export default ___CSS_LOADER_EXPORT___;
